import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import mylogin from './my-login.svg'
import {
  redirectAfterAuth,
  setToken
} from 'pobble-components/dist/auth-helpers'
import { useLocation, useHistory } from 'react-router-dom'
import Spinner from 'pobble-components/dist/spinner'
import { apiClient } from 'pobble-components/dist/api'
import { getFinishSignupStatus } from '../../common/api/me.selectors'
import EVENTS from '../../events'
import Auth from '../auth/auth'
import { ENV } from 'pobble-components/dist/setup'
import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { REDIRECT_AFTER_AUTH_FLAG } from '../../common/redirect-after-auth-flag'

const OPTIONS = {
  prod: {
    clientId: '455A0392-26CB-4B5D-A5E6-BF14EA7731D2',
    redirectUri: 'https://app.pobble.com/auth/mylogin-callback'
  },
  stg: {
    clientId: '8e5262f6-d117-463e-86ed-e7d9c0022920',
    redirectUri: 'https://stg-app.pobble.com/auth/mylogin-callback'
  },
  local: {
    clientId: '8e5262f6-d117-463e-86ed-e7d9c0022920',
    redirectUri: 'http://localhost:3000/mylogin-callback'
  }
}

const MY_LOGIN_URL = `https://app.mylogin.com/oauth/authorize?client_id=${
  OPTIONS[ENV].clientId
}&redirect_uri=${OPTIONS[ENV].redirectUri}&response_type=code`

export const MyLoginOauthCallback = injectSheet({
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '200px'
  }
})(function MyLoginOauthCallback({ classes }) {
  const { search } = useLocation()
  const history = useHistory()
  const searchParams = new URLSearchParams(search)
  const code = searchParams.get('code')
  const redirectVariant = useFeatureFlagVariantKey(REDIRECT_AFTER_AUTH_FLAG)

  useEffect(
    () => {
      apiClient
        .post(
          `v3/mylogin_authentication`,
          { code, signup_origin: localStorage.getItem('origin') },
          {
            params: {
              include: 'account.finish_signup_status'
            }
          }
        )
        .then(res => {
          if (!res || !res.data || !res.data.jwt) return
          setToken(res.data.jwt)
          const FSUStatus = getFinishSignupStatus(res.data)

          EVENTS.onOauthSignin({ provider: 'mylogin' }).then(res => {
            !FSUStatus.finished
              ? history.push('/finish-signup')
              : redirectAfterAuth(redirectVariant === 'test')
          })
        })
    },
    [code, history, redirectVariant]
  )

  return (
    <Auth>
      <div className={classes.container}>
        <Spinner />
      </div>
    </Auth>
  )
})

export const MyLoginOauth = injectSheet({
  button: {
    background: '#fff',
    color: 'var(--gray)',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    borderColor: '#CDCDCD',
    '& > div': {
      height: '16px !important'
    },
    '&:hover, &:focus': {
      background: '#fff',
      borderColor: '#999'
    }
  },
  icon: {
    width: '14px',
    height: '14px'
  },
  spinner: {
    fontSize: '14px',
    color: 'var(--gray--)',
    height: '1em !important',
    width: '1em !important'
  }
})(({ classes, history }) => {
  return (
    <Button
      _blank
      href={MY_LOGIN_URL}
      className={`${classes.button} metrics__oauth--mylogin`}
      tall
      icon={<img className={classes.icon} src={mylogin} alt="MyLogin" />}>
      Continue with MyLogin
    </Button>
  )
})
